import { render, staticRenderFns } from "./FooterEntry.vue?vue&type=template&id=497cd48a&"
import script from "./FooterEntry.vue?vue&type=script&lang=js&"
export * from "./FooterEntry.vue?vue&type=script&lang=js&"
import style0 from "./FooterEntry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports